import fitText from './fitText'

export default function wrapRoomName(
  ctx: CanvasRenderingContext2D,
  text: string,
  maxWidth: number,
  maxLines: number,
) {
  const { width: fullWidth } = ctx.measureText(text)
  if (fullWidth <= maxWidth) {
    return [text]
  }

  const parts = text.split(' ').filter(p => p !== '')
  const lines: string[] = []
  let currentLine = ''
  let idx = 0

  while (idx < parts.length && lines.length < maxLines - 1) {
    const part = parts[idx]
    const acc = currentLine === '' ? part : `${currentLine} ${part}`
    const measured = ctx.measureText(acc)
    if (measured.width > maxWidth) {
      if (currentLine === '') break
      lines.push(currentLine)
      currentLine = part
    } else {
      currentLine = acc
    }
    idx++
  }

  let lastLine = [currentLine, ...parts.slice(idx)].join(' ').trim()
  while (lines.length < maxLines && lastLine.length) {
    const potentialTextLength = Math.round(
      (lastLine.length * maxWidth) / fullWidth,
    )
    const substr = fitText(ctx, potentialTextLength, lastLine, maxWidth)
    lines.push(substr)
    lastLine = lastLine.substring(substr.length)
  }
  if (lastLine.length) {
    lines[lines.length - 1] = `${lines[lines.length - 1].substring(
      0,
      lines[lines.length - 1].length - 2,
    )}...`
  }

  return lines
}
